export default "__VITE_ASSET__4230ac81__"